import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Statusbar from '../master_root/statusbar';
//page links  
export default function Mywork() {
  return (
    <div>
      <Statusbar data={'Work history'}/>
      <div className='app_header_height'></div>
   
    <div className="container_roots">
  
  <Helmet>
  <title>Browse Job Tasks | EditorTask - Find & Hire Creative Talent</title>

  <meta name="description" content="Discover the latest freelance job tasks listed on EditorTask. From video editing to digital marketing, connect with top talent across India." />
  <meta name="keywords" content="job listings, freelance tasks, hire editors, creative work, India job portal, remote jobs, task board, EditorTask jobs" />
  <meta name="author" content="editortask.com" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="Browse Job Tasks | EditorTask - Find & Hire Creative Talent" />
  <meta property="og:description" content="Explore freelance and project-based job tasks posted on EditorTask. Connect with skilled editors, designers, marketers, and more." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.editortask.com/jobs" />
  <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
</Helmet>

<div className="container_size">
      <div className='post-container'>
      <div className="contact-title">Explore Messageing | EditorTask - Get Work Done Faster</div>   
      </div>   
        <div className='post-container'>
          <div className='post_updates row_body'> 



          </div>
          <div className='post_div row_body'></div>
        </div>
      
      </div>
      
</div>
</div>
    );
}
